export default function PHP_array_rand() {
  return (
    <div>
      <h1>PHP_array_rand</h1>
    </div>
  );
}
